import {createStore, withProps} from '@ngneat/elf';
import {localStorageStrategy, persistState} from '@ngneat/elf-persist-state';

export const FeatureFlagStoreKey = 'feature-flag';

export interface FeatureFlag {
  value: boolean;
  name: string;
}

export interface FeatureFlagListItem {
  value: boolean;
  name: string;
  key: string;
}

export interface FeatureFlagDataState {
  // [NEW-GROUP] - disabled for ticket DASH-1168
  // groupsFeature: FeatureFlag;
}

// [NEW-GROUP] - disabled for ticket DASH-1168
// export enum FeatureFlagName {
//   GROUPS_FEATURE = 'groupsFeature',
// }

export type FeatureFlagName = string;

// [NEW-GROUP] - disabled for ticket DASH-1168
// export function createInitialFeatureFlagDataState(): FeatureFlagDataState {
//   return {
//     [FeatureFlagName.GROUPS_FEATURE]: {
//       value: false,
//       name: 'Show New Groups',
//     },
//   };
// }

// [NEW-GROUP] - disabled for ticket DASH-1168
// export function createInitialFeatureFlagDataState(): FeatureFlagDataState {
//   return {
//     [FeatureFlagName.GROUPS_FEATURE]: {
//       value: false,
//       name: 'Show New Groups',
//     },
//   };
// }

export function createInitialFeatureFlagDataState(): FeatureFlagDataState {
  return {};
}

export const featureFlagStore = createStore(
  {name: FeatureFlagStoreKey},
  withProps<FeatureFlagDataState>(createInitialFeatureFlagDataState()),
);

persistState(featureFlagStore, {key: FeatureFlagStoreKey, storage: localStorageStrategy});
